// Platform helpers for iOS wrapper (WKWebView) compatibility
const ua = () => (typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

export const isIOSDevice = () =>
  /iPad|iPhone|iPod/.test(ua()) ||
  (/Macintosh/.test(ua()) && typeof document !== 'undefined' && 'ontouchend' in document);

// True inside the native iOS wrapper (WKWebView) or an installed iOS PWA,
// where OAuth popups / window.open('_blank') are blocked.
export const isIOSWebView = () => {
  if (!isIOSDevice()) return false;
  const agent = ua();
  const standalone = typeof navigator !== 'undefined' && navigator.standalone === true;
  const inAppBrowser = !/Safari/.test(agent) && !/CriOS|FxiOS|EdgiOS/.test(agent);
  return standalone || inAppBrowser || /WKWebView|MyLocalGo/i.test(agent);
};

// True only when the native iOS wrapper exposes its Google Sign-In bridge
export const hasNativeGoogleBridge = () =>
  typeof window !== 'undefined' &&
  Boolean(window.webkit?.messageHandlers?.nativeGoogleSignIn);

// Firebase popups don't work in WKWebView / standalone iOS -> use redirect flow
export const shouldUseAuthRedirect = () => isIOSWebView();

const openUrl = (url) => {
  if (isIOSWebView()) {
    // _blank is swallowed by WKWebView unless the native side handles it
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};

export const openDirections = ({ lat, lng, query }) => {
  const ios = isIOSDevice();
  if (lat && lng) {
    openUrl(ios
      ? `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`
      : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`);
    return;
  }
  const q = encodeURIComponent(query || '');
  openUrl(ios
    ? `https://maps.apple.com/?q=${q}`
    : `https://www.google.com/maps/search/?api=1&query=${q}`);
};

export const openExternalLink = (url) => openUrl(url);
